export function eventEmitter() {
  const listeners = {};

  function off(event, listener) {
    if (listeners[event] === undefined) {
      return;
    }

    listeners[event] = listeners[event].filter(registered => registered !== listener);
  }

  return {
    on(event, listener) {
      if (listeners[event] === undefined) {
        listeners[event] = [];
      }

      listeners[event].push(listener);
      return () => {
        off(event, listener);
      };
    },

    off,

    emit(event, payload) {
      if (listeners[event] === undefined) {
        return;
      }

      listeners[event].forEach(listener => listener(event, payload));
    }

  };
}